import { useCallback } from "react";
import Modal from "@/shared/ui/modal/Modal";
import { VehicleSpawnMenu } from "@/domains/vehicleSpawn/components/VehicleSpawnMenu/VehicleSpawnMenu";
import { VehicleSpawnInfo } from "@/domains/vehicleSpawn/types";

type Props = {
  open: boolean;
  onClose: () => void;
  vehicles: VehicleSpawnInfo[];
  isLoading: boolean;
  onSpawnClick: (vehicleId: number) => void;
};

export function VehicleSpawnModal({ open, onClose, ...rest }: Props) {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className="w-fit p-0"
      classNameCloseBtn="top-6.5 right-7.5"
      overlay={false}
      style={{ boxShadow: "none", fontFamily: "TT Norms Pro" }}
    >
      <VehicleSpawnMenu {...rest} />
    </Modal>
  );
}
